import styles from './YearPicker.module.scss'

type YearPickerProps = {
  years: Array<string>,
  name: string,
  year: string,
  setYear?: (year: string) => void
}

export function YearPicker({ years, name, year, setYear }: YearPickerProps) {


  if (years.length < 2) return null

  const yearOptions = years.map(value => {
    const id = name + '-' + value
    const checked = value === year
    return (
      <span key={id} className={styles.radioWrap}>
        <input id={id} type='radio' onChange={ ev => setYear && setYear(ev.target.value) } name={name} value={value} checked={checked} />
        <label htmlFor={id}>{ value }</label>
      </span>
    )
  })


  return (
    <div className={styles.yearPicker}>
      <span>When are you going?</span>
      <span>
        { yearOptions }
      </span>
    </div>
  )
}